"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findOpenHouseRoomSpot = exports.addRandomCatOrDog = exports.addRandomSmoke = exports.addRandomFire = void 0;
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueStats_sidecar_1 = require("../ui/rogueStats-sidecar");
var rogueGenHouse_render_1 = require("./rogueGenHouse_render");
var rogueMaps_sidecar_1 = require("./rogueMaps-sidecar");
var addRandomFire = function (house, map) {
    var _a = (0, rogueGenHouse_render_1.getHouseOffset)(house), ox = _a.ox, oy = _a.oy;
    var room = rando_sidecar_1.rando.sample(house.rooms);
    var m = rogueMonsters_sidecar_1.rogueMonsters.create('F');
    var _b = (0, exports.findOpenHouseRoomSpot)(house, map, room), x = _b.x, y = _b.y;
    rogueMonsters_sidecar_1.rogueMonsters.setPos(m, x, y);
    // rogueMaps.setTile(map, x + ox, y + oy, ETile.Floor, floorColor)
};
exports.addRandomFire = addRandomFire;
var addRandomSmoke = function (house, map) {
    var _a = (0, rogueGenHouse_render_1.getHouseOffset)(house), ox = _a.ox, oy = _a.oy;
    var room = rando_sidecar_1.rando.sample(house.rooms);
    var m = rogueMonsters_sidecar_1.rogueMonsters.create('f');
    var _b = (0, exports.findOpenHouseRoomSpot)(house, map, room), x = _b.x, y = _b.y;
    rogueMonsters_sidecar_1.rogueMonsters.setPos(m, x, y);
    // rogueMaps.setTile(map, x + ox, y + oy, ETile.Floor, floorColor)
};
exports.addRandomSmoke = addRandomSmoke;
var addRandomCatOrDog = function (house, map) {
    var _a = (0, rogueGenHouse_render_1.getHouseOffset)(house), ox = _a.ox, oy = _a.oy;
    var room = rando_sidecar_1.rando.sample(house.rooms);
    var pets = ['c', 'c', 'c', 'd', 'd', 'd'];
    if (rogueStats_sidecar_1.rogueStats.getStats().depth > 2) {
        pets.push('b');
    }
    if (rogueStats_sidecar_1.rogueStats.getStats().depth > 3) {
        pets.push('h');
    }
    var mType = rando_sidecar_1.rando.sample(pets);
    var m = rogueMonsters_sidecar_1.rogueMonsters.create(mType);
    var _b = (0, exports.findOpenHouseRoomSpot)(house, map, room), x = _b.x, y = _b.y;
    rogueMonsters_sidecar_1.rogueMonsters.setPos(m, x, y);
    // rogueMaps.setTile(map, x + ox, y + oy, ETile.Floor, floorColor)
};
exports.addRandomCatOrDog = addRandomCatOrDog;
var findOpenHouseRoomSpot = function (house, map, room) {
    var _a = (0, rogueGenHouse_render_1.getHouseOffset)(house), ox = _a.ox, oy = _a.oy;
    var l = room.x + ox;
    var r = room.x + room.w - 1 + ox;
    var t = room.y + oy;
    var b = room.y + room.h - 1 + oy;
    // Random tries to find an open spot
    for (var iTry = 0; iTry < 100; iTry++) {
        var x_1 = rando_sidecar_1.rando.i(l, r);
        var y_1 = rando_sidecar_1.rando.i(t, b);
        if (rogueMaps_sidecar_1.rogueMaps.isOpen(map, x_1, y_1)) {
            return { x: x_1, y: y_1, found: true };
        }
    }
    // Scan for an open spot
    for (var x_2 = l; x_2 <= r; x_2++) {
        for (var y_2 = t; y_2 <= b; y_2++) {
            if (rogueMaps_sidecar_1.rogueMaps.isOpen(map, x_2, y_2)) {
                return { x: x_2, y: y_2, found: true };
            }
        }
    }
    // No open spots, just return a random spot
    // Put it somewhere!
    console.log('warning: no open spot found in room');
    var x = rando_sidecar_1.rando.i(l, r);
    var y = rando_sidecar_1.rando.i(t, b);
    return { x: x, y: y, found: false };
};
exports.findOpenHouseRoomSpot = findOpenHouseRoomSpot;
